let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("22k4A")).then(() => parcelRequire('lO2PB'));